import { Empty } from "antd";
import {
  IoChatbubbleEllipses,
  IoHeartSharp,
  IoPlay,
  IoVolumeMediumSharp,
  IoVolumeMuteSharp,
} from "react-icons/io5";
import { formatCnt } from "../../../utils/formatCnt";
import test_img from "../../../../images/32637972_7843794.jpg";
import { useRef, useState } from "react";

export const InstagramContents = ({ instagram }) => {
  const contents = instagram || [];
  const [hoveredVideoId, setHoveredVideoId] = useState(null);
  const [isMuted, setIsMuted] = useState(true);
  const videoRefs = useRef({});

  const handleOpenContent = (url) => {
    if (!url) return;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const getContentId = (content) => content.permalink;

  const handleVideoMouseEnter = (content) => {
    const contentId = getContentId(content);
    setHoveredVideoId(contentId);

    const videoElement = videoRefs.current[contentId];
    if (!videoElement) return;

    videoElement.play().catch(() => {
      // 브라우저 autoplay 정책에 막히면 무음 상태 유지
    });
  };

  const handleVideoMouseLeave = (content, index) => {
    const contentId = getContentId(content);
    setHoveredVideoId(null);

    const videoElement = videoRefs.current[contentId];
    if (!videoElement) return;

    videoElement.pause();
  };

  const handleToggleMute = (e) => {
    e.stopPropagation();

    const nextMuted = !isMuted;
    setIsMuted(nextMuted);
  };

  return (
    <>
      {contents.length > 0 ? (
        <>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {contents.map((content, index) => {
              const contentId = getContentId(content);

              return content.media_type === "video" ? (
                <div
                  key={contentId}
                  className="group overflow-hidden rounded-[24px] border border-[#ebeff5] text-left shadow-[0_8px_24px_rgba(15,23,42,0.06)] transition-shadow duration-300 hover:shadow-[0_18px_40px_rgba(15,23,42,0.12)]"
                  onMouseEnter={() => handleVideoMouseEnter(content, index)}
                  onMouseLeave={() => handleVideoMouseLeave(content, index)}
                  onClick={() => handleOpenContent(content.permalink)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      handleOpenContent(content.permalink);
                    }
                  }}
                  role="button"
                  tabIndex={0}
                >
                  <div className="relative aspect-[3/4] overflow-hidden">
                    <img
                      src={content.thumbnail || test_img}
                      alt="인스타그램 썸네일"
                      className={`absolute inset-0 scale-[1.01] h-full w-full object-cover transition-all duration-300 ${
                        hoveredVideoId === contentId
                          ? "scale-[1.03] opacity-0"
                          : "scale-100 opacity-100"
                      }`}
                      onError={(e) => {
                        e.currentTarget.src = test_img;
                      }}
                    />
                    <video
                      ref={(element) => {
                        if (element) {
                          videoRefs.current[contentId] = element;
                        }
                      }}
                      src={content.media}
                      poster={content.thumbnail || test_img}
                      className={`absolute inset-0 scale-[1.01] h-full w-full object-cover rounded-[inherit] will-change-transform transition-opacity duration-300 ${
                        hoveredVideoId === contentId
                          ? "opacity-100"
                          : "opacity-0"
                      }`}
                      muted={isMuted}
                      loop
                      playsInline
                      preload="metadata"
                    />
                    {hoveredVideoId === contentId ? (
                      <button
                        type="button"
                        className="absolute right-3 top-3 z-10 inline-flex h-9 w-9 md:h-7 md:w-7 items-center justify-center rounded-full bg-black/55 text-white backdrop-blur-sm transition hover:bg-black/70"
                        onClick={handleToggleMute}
                        aria-label={isMuted ? "소리 켜기" : "소리 끄기"}
                      >
                        {isMuted ? (
                          <IoVolumeMuteSharp className="text-[16px] md:text-[12px]" />
                        ) : (
                          <IoVolumeMediumSharp className="text-[16px] md:text-[12px]" />
                        )}
                      </button>
                    ) : null}
                  </div>
                  <div className="text-[14px] md:text-[12px] text-[#595959] space-y-1 p-4">
                    <p className="flex items-center gap-1.5 m-0 truncate">
                      <IoPlay className="text-[#13C2C2]" />
                      <span>{formatCnt(content.view_count || 0)}</span>
                    </p>
                    <p className="flex items-center gap-1.5 m-0 truncate">
                      <IoHeartSharp className="text-[#FF4D4F]" />
                      <span>{formatCnt(content.like_count || 0)}</span>
                    </p>
                    <p className="flex items-center gap-1.5 m-0 truncate">
                      <IoChatbubbleEllipses className="text-[#1890FF]" />
                      <span>{formatCnt(content.comment_count || 0)}</span>
                    </p>
                    <p className="text-[14px] md:text-[12px] mt-[6px] md:mt-[8px] mb-0 text-[#1890FF] overflow-hidden text-ellipsis whitespace-nowrap font-medium min-h-[16px] md:min-h-[20px]">
                      {content.caption}
                    </p>
                  </div>
                </div>
              ) : (
                <div
                  key={content.permalink || index}
                  onClick={() => handleOpenContent(content.permalink)}
                  className="group overflow-hidden rounded-[24px] border border-[#ebeff5] text-left shadow-[0_8px_24px_rgba(15,23,42,0.06)] transition-shadow duration-300 hover:shadow-[0_18px_40px_rgba(15,23,42,0.12)]"
                >
                  <div className="relative aspect-[3/4] overflow-hidden">
                    <img
                      src={content.thumbnail || test_img}
                      alt="인스타그램 썸네일"
                      className={`absolute inset-0 scale-[1.01] h-full w-full object-cover transition-all duration-300`}
                      onError={(e) => {
                        e.currentTarget.src = test_img;
                      }}
                    />
                  </div>
                  <div className="text-[14px] md:text-[12px] text-[#595959] space-y-1 p-4">
                    <p className="flex items-center gap-1.5 m-0 truncate">
                      <IoPlay className="text-[#13C2C2]" />
                      <span>{formatCnt(content.view_count || 0)}</span>
                    </p>
                    <p className="flex items-center gap-1.5 m-0 truncate">
                      <IoHeartSharp className="text-[#FF4D4F]" />
                      <span>{formatCnt(content.like_count || 0)}</span>
                    </p>
                    <p className="flex items-center gap-1.5 m-0 truncate">
                      <IoChatbubbleEllipses className="text-[#1890FF]" />
                      <span>{formatCnt(content.comment_count || 0)}</span>
                    </p>
                    <p className="text-[14px] md:text-[12px] mt-[6px] md:mt-[8px] mb-0 text-[#1890FF] overflow-hidden text-ellipsis whitespace-nowrap font-medium min-h-[16px] md:min-h-[20px]">
                      {content.caption}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <Empty
          description={
            <div className="text-[14px] text-[#666]">
              브랜드 콘텐츠가 없습니다.
            </div>
          }
        />
      )}
    </>
  );
};
